import type { TextLevel } from "../Text/TextLevel";
import type { FC, ReactNode } from "react";
import type { TextStyle } from "react-native";

import { Text } from "../Text";

export interface WrapWithTextIfNeededProps {
  children: ReactNode;
  level?: TextLevel;
  sx?: TextStyle;
}

/**
 * Utility component that wraps string children with Text component when needed
 * @param children - The content to potentially wrap
 * @param level - Text level for styling
 * @param sx - Additional text styles
 */
export const WrapWithTextIfNeeded: FC<WrapWithTextIfNeededProps> = ({ children, level, sx }) => {
  if (typeof children === "string") {
    return (
      <Text level={level} sx={sx}>
        {children}
      </Text>
    );
  }
  return <>{children}</>;
};
